import { z } from "zod";

import HorizontalBar, {
  type HorizontalBarProps,
} from "@/components/ui/chat/horizontal-bar/HorizontalBar";
import { chartHexColorSchema } from "@/lib/utils/chartUtils";

export const ChatHorizontalBarSpec = {
  props: z.object({
    segments: z.array(
      z.object({
        label: z.string(),
        value: z.number(),
        color: chartHexColorSchema.nullable().optional(),
      }),
    ),
    showLabels: z.boolean().nullable().optional(),
    showValues: z.boolean().nullable().optional(),
    height: z.enum(["sm", "md", "lg"]).nullable().optional(),
  }),
  description:
    "Compact stacked horizontal bar for proportions (e.g. sentiment). More compact than a full chart. Props: segments (array of { label, value, color? }, where color is optional #RGB or #RRGGBB), showLabels (boolean or null), showValues (boolean or null), height ('sm' | 'md' | 'lg' or null). Use { \"$state\": \"/path\" } on props when binding read-only data. When color is omitted, labels containing positive, negative, or neutral use sentiment colors; other labels use chart palette tokens.",
  example: {
    segments: [
      { label: "Positive", value: 64 },
      { label: "Neutral", value: 15 },
      { label: "Negative", value: 21 },
    ],
    showLabels: true,
    showValues: true,
  },
} as const;

/** Renders {@link HorizontalBar} from catalog props (validated by the spec schema). */
export const ChatHorizontalBarFromProps = ({
  props,
}: {
  props: Record<string, unknown>;
}) => {
  const typed = props as HorizontalBarProps["props"];
  return <HorizontalBar props={typed} />;
};
